// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__3w7KP","content":"RecentSearches_content__2Ioz7"};